import { useMemo } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import cln from 'classnames';

import { Switch } from 'components';
import starFilled from 'assets/img/star_filled.svg';
import { useStore } from 'store';
import { useWindowSize } from 'hooks';

const STARS = [1, 2, 3, 4];

export default function RatingFilter({ className }) {
  const { isMobile } = useWindowSize()[1];

  const [listOfGifts] = useStore((state) =>
    _get(state, `gifts.listOfGifts.results.${isMobile ? 'mobileList' : 'list'}`, [])
  );

  const withHightRating = useMemo(
    () => listOfGifts.some((product) => Number(product.review) > 3),
    [listOfGifts]
  );

  return withHightRating && (
    <div className={cln('py-2 d-flex justify-content-between', className)}>
      <span className="d-flex justify-content-center align-items-center">
        {STARS.map((item) => (
          <img key={item} src={starFilled} alt="Estrellas filtro" />
        ))}
        &nbsp; o más
      </span>
      <Switch name="highRating" hasDefault />
    </div>
  );
}

RatingFilter.propTypes = {
  className: PropTypes.string
};
